import * as React from "react"
import { useCallback } from "react"
import Map, { Marker, NavigationControl } from "react-map-gl"
import { initialViewState, MAPBOX_TOKEN, MAP_STYLE } from "../../constants"

import Pin from "./Pin"
import "mapbox-gl/dist/mapbox-gl.css"

import mapboxgl from "mapbox-gl"; // This is a dependency of react-map-gl even if you didn't explicitly install it

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

export default function ChooseSingleLocation({ marker, setMarker }) {
  const onMarkerDrag = useCallback((event) => {
    setMarker({
      longitude: event.lngLat.lng,
      latitude: event.lngLat.lat,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{ width: "100%" }}>
      <Map
        initialViewState={initialViewState}
        mapStyle={MAP_STYLE}
        mapboxAccessToken={MAPBOX_TOKEN}
        style={{ width: "100%", height: 400 }}
      >
        <Marker
          longitude={marker.longitude}
          latitude={marker.latitude}
          anchor="bottom"
          draggable
          onDrag={onMarkerDrag}
        >
          <Pin size={20} />
        </Marker>

        <NavigationControl />
      </Map>
    </div>
  )
}
